import Recommendations from "./Recommendations.component";

export default Recommendations;
